import script from "./PrintNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintNotes.vue?vue&type=script&setup=true&lang=js"

import "./PrintNotes.vue?vue&type=style&index=0&id=6eaa0373&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eaa0373"]])

export default __exports__